import { lazy } from 'react'
import logo from './assets/logo.svg'

const wholesalersModule = {
  meta: {
    logo,
    name: 'wholesalers',
    title: 'Atacadistas',
    path: '/wholesalers/dashboard'
  },
  routes: [
    {
      name: 'Dashboard',
      path: '/wholesalers/dashboard',
      exact: true,
      component: lazy(() => import('./pages/Dashboard')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_dashboard:show']
      }
    },
    {
      name: 'Devices',
      path: '/wholesalers/devices',
      exact: true,
      component: lazy(() => import('./pages/Devices')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_devices:list']
      }
    },
    {
      name: 'Customers',
      path: '/wholesalers/customers',
      exact: true,
      component: lazy(() => import('./pages/Customers')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_customers:list']
      }
    },
    {
      name: 'NewCustomer',
      path: '/wholesalers/customers/new',
      exact: true,
      component: lazy(() => import('./pages/Customers/CustomerForm')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_customers:create']
      }
    },
    {
      name: 'EditCustomer',
      path: '/wholesalers/customers/:id/edit',
      exact: true,
      component: lazy(() => import('./pages/Customers/CustomerForm')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_customers:edit']
      }
    },
    {
      name: 'CustomerDetails',
      path: '/wholesalers/customers/:id',
      exact: true,
      component: lazy(() => import('./pages/Customers/CustomerDetails')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_customers:show']
      }
    },
    {
      name: 'CustomerSales',
      path: '/wholesalers/sales',
      exact: true,
      component: lazy(() => import('./pages/CustomerSales')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_sales:list']
      }
    },
    {
      name: 'Payments',
      path: '/wholesalers/payments',
      exact: true,
      component: lazy(() => import('./pages/Payments')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_payments:list']
      }
    },
    {
      name: 'Plans',
      path: '/wholesalers/plans',
      exact: true,
      component: lazy(() => import('./pages/Plans')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_plans:list']
      }
    },
    {
      name: 'BankAccounts',
      path: '/wholesalers/bank-accounts',
      component: lazy(() => import('./pages/BankAccounts')),
      meta: {
        isPrivate: true,
        permissions: ['wholesaler_bank_accounts:list']
      }
    }
  ]
}

export default wholesalersModule
